import { writeSliceModel, upsertGlobalTypeScriptTypes, writeSliceFile } from "@prismicio/plugin-kit/fs";
import { stripIndent } from "common-tags";
import { rejectIfNecessary } from "../lib/rejectIfNecessary.js";
import { upsertSliceLibraryIndexFile } from "../lib/upsertSliceLibraryIndexFile.js";
var __freeze = Object.freeze;
var __defProp = Object.defineProperty;
var __template = (cooked, raw) => __freeze(__defProp(cooked, "raw", { value: __freeze(raw || cooked.slice()) }));
var _a;
const createComponentFile = async ({ data, helpers, actions, options }) => {
  const contents = data.componentContents ?? stripIndent(_a || (_a = __template(['\n			<template>\n				<section\n					:data-slice-type="slice.slice_type"\n					:data-slice-variation="slice.variation"\n				>\n					Placeholder component for ', ' (variation: {{ slice.variation }}) Slices\n					<br />\n					<strong>You can edit this slice directly in your code editor.</strong>\n					<!--\n					💡 Use the Prismic MCP server with your code editor\n					📚 Docs: https://prismic.io/docs/ai#code-with-prismics-mcp-server\n					-->\n				</section>\n			</template>\n\n			<script>\n			import { getSliceComponentProps } from "@prismicio/vue/components";\n\n			export default {\n				// The array passed to `getSliceComponentProps` is purely optional.\n				// Consider it as a visual hint for you when templating your slice.\n				props: getSliceComponentProps(["slice", "index", "slices", "context"]),\n			};\n			<\/script>\n		'], ['\n			<template>\n				<section\n					:data-slice-type="slice.slice_type"\n					:data-slice-variation="slice.variation"\n				>\n					Placeholder component for ', ' (variation: {{ slice.variation }}) Slices\n					<br />\n					<strong>You can edit this slice directly in your code editor.</strong>\n					<!--\n					💡 Use the Prismic MCP server with your code editor\n					📚 Docs: https://prismic.io/docs/ai#code-with-prismics-mcp-server\n					-->\n				</section>\n			</template>\n\n			<script>\n			import { getSliceComponentProps } from "@prismicio/vue/components";\n\n			export default {\n				// The array passed to \\`getSliceComponentProps\\` is purely optional.\n				// Consider it as a visual hint for you when templating your slice.\n				props: getSliceComponentProps(["slice", "index", "slices", "context"]),\n			};\n			<\/script>\n		'])), data.model.id);
  await writeSliceFile({
    libraryID: data.libraryID,
    model: data.model,
    filename: "index.vue",
    contents,
    format: options.format,
    actions,
    helpers
  });
};
const sliceCreate = async (data, context) => {
  rejectIfNecessary(await Promise.allSettled([
    writeSliceModel({
      libraryID: data.libraryID,
      model: data.model,
      format: context.options.format,
      helpers: context.helpers
    }),
    createComponentFile({ data, ...context })
  ]));
  rejectIfNecessary(await Promise.allSettled([
    upsertSliceLibraryIndexFile({
      libraryID: data.libraryID,
      ...context
    }),
    upsertGlobalTypeScriptTypes({
      filename: context.options.generatedTypesFilePath,
      format: context.options.format,
      helpers: context.helpers,
      actions: context.actions
    })
  ]));
};
export {
  sliceCreate
};
//# sourceMappingURL=slice-create.js.map
